import React, { useEffect, useState } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import AdminSidebar from "../shared/AdminSidebar";
import "./Users.css";
import { Container, Alert, Modal, Button } from "react-bootstrap";
import EditUserModal from "../userEdit/userEdit";

const Users = () => {
  const [users, setUsers] = useState([]);
  const [message, setMessage] = useState("");
  const [showEditModal, setShowEditModal] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState({
    show: false,
    type: "single",
    user: null,
  });

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = () => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/users.php`)
      .then((response) => {
        if (Array.isArray(response.data)) {
          setUsers(response.data);
        } else {
          console.error("Error: Expected an array of users");
        }
      })
      .catch((error) => {
        console.error("Error fetching users:", error);
      });
  };

  const handleEvaluate = (id) => {
    axios
      .post(`${process.env.REACT_APP_BASE_URL}/moveToEvaluateur.php`, { id })
      .then((response) => {
        // Debug: log the full response
        console.log("moveToEvaluateur.php response:", response.data);

        if (response.data && typeof response.data === "object") {
          if (response.data.error) {
            setMessage(response.data.error);
          } else if (response.data.message) {
            setMessage(response.data.message);
            const updatedUsers = users.map((user) =>
              user.idchercheur === id ? { ...user, isEvaluateur: true } : user
            );
            setUsers(updatedUsers);
          } else {
            setMessage("No message or error returned from server.");
          }
        } else {
          setMessage("Invalid response from server.");
        }
      })
      .catch((error) => {
        setMessage("Network or server error.");
        console.error("Error moving user to evaluateur:", error);
      });
  };

  const handleDelete = (id) => {
    const selectedUser = users.find((user) => user.idchercheur === id);
    if (!selectedUser) {
      setMessage("Utilisateur introuvable.");
      return;
    }

    if (selectedUser.isEvaluateur) {
      setDeleteDialog({ show: true, type: "choice", user: selectedUser });
    } else {
      setDeleteDialog({ show: true, type: "single", user: selectedUser });
    }
  };

  const closeDeleteDialog = () => {
    setDeleteDialog({ show: false, type: "single", user: null });
  };

  const performDeletion = (id, targetTable) => {
    if (!id || !targetTable) return;

    axios
      .post(`${process.env.REACT_APP_BASE_URL}/deleteUser.php`, {
        id,
        target: targetTable,
      })
      .then((response) => {
        if (response.data?.success) {
          if (targetTable === "chercheur") {
            setUsers((prevUsers) =>
              prevUsers.filter((user) => user.idchercheur !== id)
            );
          } else {
            setUsers((prevUsers) =>
              prevUsers.map((user) =>
                user.idchercheur === id
                  ? { ...user, isEvaluateur: false }
                  : user
              )
            );
          }
          setMessage(response.data.message || "Suppression effectuée avec succès.");
        } else {
          setMessage(
            response.data?.error ||
              "Échec de la suppression. Veuillez réessayer plus tard."
          );
        }
      })
      .catch((error) => {
        console.error("Error deleting user:", error);
        setMessage("Erreur réseau ou serveur lors de la suppression.");
      })
      .finally(() => {
        closeDeleteDialog();
      });
  };

  const handleEdit = (user) => {
    setCurrentUser(user);
    setShowEditModal(true);
  };

  const handleSave = (id, updatedUser) => {
    axios
      .post(`${process.env.REACT_APP_BASE_URL}/updateUser.php`, {
        id,
        ...updatedUser,
      })
      .then((response) => {
        if (response.data.success) {
          setUsers((prevUsers) =>
            prevUsers.map((user) =>
              user.idchercheur === id ? { ...user, ...updatedUser } : user
            )
          );
          setMessage("User updated successfully");
          setShowEditModal(false);
        } else {
          setMessage(response.data.error);
        }
      })
      .catch((error) => {
        console.error("Error updating user:", error);
      });
  };

  return (
    <div className="users-container">
      <AdminSidebar />
      <div className="users-main admin-content">
        <Container
          className="users-content"
          style={{ maxWidth: "1200px", margin: "0 auto" }} // centered content
        >
          <h2 className="users-title" style={{ textAlign: "center" }}>
            Liste des Chercheurs
          </h2>
          {message && <Alert variant="info">{message}</Alert>}
          <div
            className="users-table-container"
            style={{ display: "flex", justifyContent: "center" }} // center table wrapper
          >
            <table
              className="users-table"
              style={{
                width: "100%",
                maxWidth: "1100px",
                margin: "0 auto",
                background: "#fff",
                borderRadius: "8px",
                overflow: "hidden",
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              }}
            >
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Nom</th>
                  <th>Prénom</th>
                  <th>Email</th>
                  <th>Téléphone</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {users.map((user, index) => (
                  <tr key={index}>
                    <td>{user.idchercheur}</td>
                    <td>
                      {user.nom}{" "}
                      {user.isEvaluateur && <span>(Évaluateur)</span>}
                    </td>
                    <td>{user.prenom}</td>
                    <td>{user.email}</td>
                    <td>{user.telephone}</td>
                    <td style={{ textAlign: "center", whiteSpace: "nowrap" }}>
                      <button
                        className="users-btn eva-btn"
                        onClick={() => handleEvaluate(user.idchercheur)}
                      >
                        Évaluateur
                      </button>
                      <button
                        className="users-btn del-btn"
                        onClick={() => handleDelete(user.idchercheur)}
                      >
                        Supprimer
                      </button>
                      <button
                        className="users-btn edit-btn"
                        onClick={() => handleEdit(user)}
                      >
                        Modifier
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Container>
        {showEditModal && (
          <EditUserModal
            show={showEditModal}
            handleClose={() => setShowEditModal(false)}
            user={currentUser}
            handleSave={handleSave}
          />
        )}
        <Modal
          show={deleteDialog.show}
          onHide={closeDeleteDialog}
          centered
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>Confirmation</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {deleteDialog.type === "single" ? (
              <p>
                Êtes-vous sûr de vouloir supprimer ce chercheur ? Cette action
                est irréversible.
              </p>
            ) : (
              <p>
                Cet utilisateur est à la fois chercheur et évaluateur. Choisissez
                la table depuis laquelle vous souhaitez le supprimer.
              </p>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={closeDeleteDialog}>
              Annuler
            </Button>
            {deleteDialog.type === "single" ? (
              <Button
                variant="danger"
                onClick={() =>
                  performDeletion(deleteDialog.user?.idchercheur, "chercheur")
                }
              >
                Supprimer
              </Button>
            ) : (
              <>
                <Button
                  variant="danger"
                  onClick={() =>
                    performDeletion(deleteDialog.user?.idchercheur, "chercheur")
                  }
                >
                  Supprimer de Chercheurs
                </Button>
                <Button
                  variant="warning"
                  onClick={() =>
                    performDeletion(deleteDialog.user?.idchercheur, "evaluateur")
                  }
                >
                  Supprimer d'Évaluateurs
                </Button>
              </>
            )}
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};

export default Users;
